import React from 'react';
import CardSimple from 'screens/components/basic/CardSimple';

const POSSales = () => {
    return (
        <div id="pos-how-to">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to use POS Sales</h2>
                        <p><b>NOTE: Before using POS Sales, make sure that you meet the following requirements:</b></p>
                        <ol>
                            <li>The device was configured by someone from the management team (See How to add a new device?/How to configure my device? sections of this document).</li>
                            <li>All the printer drivers are installed and configured. </li>
                            <li>All the equipment (cash drawer, printers, scales, etc.) is plugged into the computer. </li>
                            <li>The Cash Register Service is installed and running. </li>
                            <li>You are an active employee with a valid email address registered in the system.</li>
                        </ol>
                        <ul>
                            <li>Log in to TechPOS using the email address registered in the system and your password.</li>
                            <li>In the menu, click on POS Sales</li>
                            <li>Make sure that at the beginning of your shift you have the cash in
                                amount that your dispensary uses. If you have more or less, contact management. Click confirm</li>
                            <li>After clicking Confirm you should be able to see the TechPOS Sales Screen</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-add-patient">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to link a Member to an order?</h2>
                        <ul>
                            <li>On the upper-left corner click on Member Search.</li>
                            <img src="http://techpos.ca/support-images/POS/LinkMember/LinkMem-1.png" />
                            <li>Look for the Member either by name, member number, phone or non-member status. NOTE: The search results
                                will appear exactly as entered (e.g. if searching for the name "Al", only the results with the exact name "Al" will
                                appear).</li>
                            <img src="http://techpos.ca/support-images/POS/LinkMember/LinkMem-2.png" />
                            <li>Click on the button Link to Order for the desired Member.</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-lookup-product">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to look for a product?</h2>
                        <ul>
                            <li>On the left side of the screen, you will see blocks containing the categories of each group select the category
                                corresponding to the product to sale.</li>
                            <img src="http://techpos.ca/support-images/POS/LookForProduct/LookForProd-1.png" />
                            <li>Select the category of the product to sell.</li>
                            <li>The list of available products will show up below the categories.</li>
                            <img src="http://techpos.ca/support-images/POS/LookForProduct/LookForProd-3.png" />
                            <li>To find a product, you can either navigate through the pagination or look for it using the text box.</li>
                            <img src="http://techpos.ca/support-images/POS/LookForProduct/LookForProd-2.png" />
                            <li>Once you have found the desired product, click on it to add it to the order</li>
                            <img src="http://techpos.ca/support-images/POS/LookForProduct/LookForProd/LookForProd-1.png" />

                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-nonCannabis-order">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to start a non-Cannabis order?</h2>
                        <p><b>NOTE: This part is for accessories and non-cannabis-related products</b></p>
                        <ul>
                            <li>Search for the desired product (See How to look for a product? Section in the document).</li>
                            <li>In the pop-up window, click on the green + sign to increase the quantity of products. Click on the red - sign to
                                decrease the quantity of products. Click on Add Product to Order once you have reached the desired quantity.</li>
                            <img src="http://techpos.ca/support-images/POS/Non-Cannabis/NonCanna-1.png" />
                            <li>If no Member is linked, the upper-right corner will display the name Member Anonymous, else it will display the
                                name of the linked Member. It's optional to link a Member (For instructions on how to link a Member, see section How
                                to link a Member to an order? in this document).</li>
                            <img src="http://techpos.ca/support-images/POS/Non-Cannabis/NonCanna-2.png" />
                        </ul>
                        <p><b>NOTE: Linking a Member for a non-cannabis-related product is optional</b></p>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-unitCannabis-order">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to start an order with a unit-Cannabis-based product?</h2>
                        <ul>
                            <li>Link a Member (for instructions on how to link a Member, see section How to link a Member to an order? In this
                                document).</li>
                            <li>Select the unit category (tear, pills, some concentrates, edibles, tinctures, topical)</li>
                            <li>Select the product from the list</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-bulkCannabis-order">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to start an order with a bulk-Cannabis-based product?</h2>
                        <ul>
                            <li>Link a Member (for instructions on how to link a Member, see section How to link a Member to an order? In this
                                document).</li>
                            <li>Search the product (refer to How to look for a product?)</li>
                            <li>If your scale is integrated, simply put your product onto the scale and hit Get Weight from Scale</li>
                            <li>If the scale is not integrated,you can add the weight manually or choose a weight from the Price Matrix</li>
                            <img src="http://techpos.ca/support-images/POS/Bulk/bulk.png" />
                            <li>Click on Add Product to Order</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-resume-order">
                <br />
                {/* <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to resume an open order for a given Member?</h2>
                        <ul>
                            <li>In the upper left corner click Options</li>
                            <img src="http://techpos.ca/support-images/POS/ResumeOrder/Resume-1.png" />
                            <li>Click on View Orders</li>
                            <img src="http://techpos.ca/support-images/POS/ResumeOrder/Resume-2.png" />
                            <li>Click Continue to resume the order</li>
                            <img src="http://techpos.ca/support-images/POS/ResumeOrder/Resume-3.png" />
                        </ul>
                    </div>
                </CardSimple> */}
            </div>
            <div id="pos-cancel-order">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to cancel an order?</h2>
                        <ul>
                            <li>In the Opened Order click on Cancel</li>
                            <img src="http://techpos.ca/support-images/POS/CancelOrder/CancelOrder-1.png" />
                            <li>Insert the Credentials</li>
                            <img src="http://techpos.ca/support-images/POS/CancelOrder/CancelOrder-2.png" />
                            <li>Click on Confirm</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-apply-discount">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to Apply a Discount?</h2>
                        <ul>
                            <li>In the Open Order Click on Apply Discount. NOTE: when applying a discount to a product in the campaign, you
                                have to remove the discount of the campaign</li>
                            <img src="http://techpos.ca/support-images/POS/Discount/Discount-1.png" />
                            <li>Select if the discount is by Product or By Order</li>
                            <img src="http://techpos.ca/support-images/POS/Discount/Discount-2.png" />
                            <li>Select the type of Discount (amount or percentage) and type the amount</li>
                            <img src="http://techpos.ca/support-images/POS/Discount/Discount-3.png" />
                            <li>Provide the credentials</li>
                            <img src="http://techpos.ca/support-images/POS/Discount/Discount-4.png" />
                            <li>Click on save</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-unable-sell-prePack">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>I’m Unable to Sell a Pre-Pack Product</h2>
                        <p><b>The main reason why a Pre-Pack Product would give an error when selling is because it doesn’t have a weight
                            per unit property. To fix it, follow the next steps:</b></p>
                        <ul>
                            <li>Go to Menu {`>`} Inventory {`>`} Products</li>
                            <li>Search for the product creating the problem</li>
                            <li>Click on Edit</li>
                            <li>Check that the field “How much weight in one unit” has a value on it and that there is a price matrix
                                attached to the product</li>
                            <li>Click on save</li>
                            <li>Try to sell the product again</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-pay-cash">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to Pay with Cash?</h2>
                        <ul>
                            <li>On the Payment Method Select Cash</li>
                            <img src="http://techpos.ca/support-images/POS/PayCash/PayCash-1.png" />
                            <li>Type the Amount or Press the buttons with the Amount</li>
                            <img src="http://techpos.ca/support-images/POS/PayCash/PayCash-2.png" />
                            <li>Print the receipt and labels</li>
                            <img src="http://techpos.ca/support-images/POS/PayCash/PayCash-3.png" />
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-pay-debit">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to Pay with Debit?</h2>
                        <ul>
                            <li>On the Payment Method Select Debit</li>
                            <img src="http://techpos.ca/support-images/POS/PayDebit/PayDebit-1.png" />
                            <li>Insert the code and type the amount to charge</li>
                            <img src="http://techpos.ca/support-images/POS/PayDebit/PayDebit-2.png" />
                            <li>Click on Confirm</li>
                            <img src="http://techpos.ca/support-images/POS/PayDebit/PayDebit-3.png" />
                            <li>Print the receipt and labels</li>
                        </ul>
                    </div>
                </CardSimple>

            </div>
            <div id="pos-inStore-credit">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to Pay with Store Credit?</h2>
                        <ul>
                            <li>On the Payment Method Select Store Credit</li>
                            <img src="http://techpos.ca/support-images/POS/PayStoreCredit/PayStoreCredit-1.png" />
                            <li>Insert the Store Credit Code and type the amount to charge</li>
                            <img src="http://techpos.ca/support-images/POS/PayStoreCredit/PayStoreCredit-2.png" />
                            <li>Click on Confirm</li>
                            <img src="http://techpos.ca/support-images/POS/PayStoreCredit/PayStoreCredit-3.png" />
                            <li>Print the receipt and labels</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-refund">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to Refund an Item?</h2>
                        <p><b>NOTE: Only a manager can refund an item. An unopened product goes to sell warehouse. A damaged product
                            goes to Damage Warehouse.</b></p>
                        <h3>Refund when no other order was performed</h3>
                        <ul>
                            <li>Click on Refund</li>
                            <img src="http://techpos.ca/support-images/POS/Refund/Refund-1.png" />
                            <li>Enter Credentials</li>
                            <img src="http://techpos.ca/support-images/POS/Refund/Refund-2.png" />
                            <li>Select the products to refund and the reason for refunding</li>
                            <img src="http://techpos.ca/support-images/POS/Refund/Refund-3.png" />
                            <li>Click on Confirm</li>
                            <li>Print the new receipt and store credit</li>
                        </ul>
                        <h3>Refund when other orders were performed</h3>
                        <ul>
                            <li>In the upper left corner click Options</li>
                            <img src="http://techpos.ca/support-images/POS/Refund/Refund-4.png" />
                            <li>Click on View Orders</li>
                            <img src="http://techpos.ca/support-images/POS/Refund/Refund-5.png" />
                            <li>Scroll down to Completed Orders</li>
                            <img src="http://techpos.ca/support-images/POS/Refund/Refund-6.png" />
                            <li>Select REOPEN on the order you wish to Refund</li>
                            <li>Follow the steps from section Refund when no other order was performed(Above)</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-cash-drop">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>Cash Drop</h2>
                        <p>Once that the amount of cash in the register have reached over $250, you will be asked to cash drop, this
                            means, return the remaining to management.</p>
                        <ul>
                            <li>When the screen pops up, click on Cash Drop</li>
                            <img src="http://techpos.ca/support-images/POS/CashDrop/CashDrop-1.png" />
                            <li>Print the cash drop</li>
                            <img src="http://techpos.ca/support-images/POS/CashDrop/CashDrop-2.png" />
                            <li>Hand in the money and one copy to management, keep the other one for your records.</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="pos-close-register">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to close the Register from POS Screen</h2>
                        <ul>
                            <li>In the upper left corner click Options</li>
                            <img src="http://techpos.ca/support-images/POS/CloseRegisterFromPOS/CloseRegPOS-2.png" />
                            <li>Click on Close Register</li>
                            <img src="http://techpos.ca/support-images/POS/CloseRegisterFromPOS/CloseRegPOS-2.png" />
                            <li>Confirm the cash out. See a manager to count all the cash in the tilt.</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default POSSales;